<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-bell"></i>
          로그
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WEBCastle</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Log</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <div v-else>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card>
            <b-row>
              <b-col>
                <strong>탐지 로그 상세 ({{model.id}})</strong>
                <span class="float-right">탐지시각 : {{model.created_at | datetime}}</span>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>클라이언트 정보</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover="">공격자: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover="" v-if="model">
                        {{model.remote_addr ? model.remote_addr : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>
                        XFF:
                        <!-- <b-badge   v-if="model.xff" variant='success'>?</b-badge> -->
                        <i style='cursor: pointer;' @click="info_xff = true" class="fas fa-question-circle"></i>
                      </label>
                    </b-col>
                    <b-col>
                      <label for="ph_remote_addr" v-b-tooltip.hover v-if="model">
                        {{ model.xff ? model.xff : '-' }}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_remote_addr" v-b-tooltip.hover>국가: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_remote_addr" v-b-tooltip.hover>
                        <span v-if="model.country" class="flag-icon" :class="set_flag(model.country)"></span>
                        {{model.country ? model.country : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_protocol" v-b-tooltip.hover>프로토콜: </label>
                    </b-col>
                    <b-col>

                      <label for="ph_protocol" v-b-tooltip.hover>
                        {{model.protocol ? model.protocol : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_port" v-b-tooltip.hover>포트: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover>
                        -
                        <!-- {{model.protocol ? model.protocol : '-'}} -->
                      </label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_src_port" v-b-tooltip.hover>메소드: </label>
                    </b-col>
                    <b-col>
                      <label for="ph_src_port" v-b-tooltip.hover>
                        {{model.method ? model.method : '-'}}
                      </label>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col style="border-left: 1px solid #dcdcdc;">
                <h4>서버 정보</h4>
                <hr>
                <div>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_host" v-b-tooltip.hover>Host(도메인):</label>
                    </b-col>
                    <b-col>
                      <label for="ph_host" v-b-tooltip.hover>{{model.host}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_host" v-b-tooltip.hover>포트:</label>
                    </b-col>
                    <b-col>
                      -
                      <!-- <label for="ph_host" v-b-tooltip.hover>{{model.host}}</label> -->
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>대상:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model">{{model.target}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>외부 아이피:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_public ? model.agent.ip_addr_public : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>내부 아이피:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.ip_addr_private ? model.agent.ip_addr_private : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>WAS:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.iwaf_type ? model.agent.iwaf_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>운영체제:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.os_type ? model.agent.os_type : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>호스트(헤더):</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.host ? model.agent.host : '-'}}</label>
                    </b-col>
                  </b-row>
                  <b-row v-if="model.agent && model.agent.nickname != model.agent.host">
                    <b-col>
                      <label class="font-weight-bold" for="ph_target" v-b-tooltip.hover>이름:</label>
                    </b-col>
                    <b-col>
                      <label for="ph_target" v-b-tooltip.hover v-if="model.agent">{{model.agent.nickname ? model.agent.nickname : '-'}}</label>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label for="ph_uri" v-b-tooltip.hover>
                        URI <small>:</small>
                        <b-button v-if="model.uri.length > 100" size="sm" @click="view_split_uri = !view_split_uri" variant="info">
                          {{view_split_uri ? 'split' : 'origin'}} view
                        </b-button>
                      </label>
                    </b-col>
                    <b-col>
                      <pre v-if="view_split_uri" for="ph_uri" v-b-tooltip.hover>{{model.uri}}</pre>
                      <pre v-else>{{split_uri(model.uri || '')}}</pre>
                    </b-col>
                  </b-row> -->

                </div>
              </b-col>
              <b-col md="6" style="border-left: 1px solid #dcdcdc;">
                <h4>
                  위험 정보
                  <Bell v-if="model.message && model.message.messages && model.message.messages.length > 1" style="display: inline-block" :size="20" :count="model.message.messages.length" />
                </h4>

                <hr>
                <div>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" for="ph_response" v-b-tooltip.hover>응답(대응):</label>
                    </b-col>
                    <b-col>
                      <b-badge v-if="model.is_block && this.model.block_cnt > 0" variant="danger">차단</b-badge>
                      <b-badge v-else variant="warning">팀지:</b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="cursor:pointer"  @click="info_risk = true" md="3">
                      <label class="font-weight-bold" for="ph_response" v-b-tooltip.hover>위험:</label>
                      <span>
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </b-col>
                    <b-col>
                      <b-badge v-if="model.severity == 0" variant="danger">긴급</b-badge>
                      <b-badge v-else-if="model.severity == 1" variant="danger">경계</b-badge>
                      <b-badge v-else-if="model.severity == 2" variant="danger">치명적</b-badge>
                      <b-badge v-else-if="model.severity == 3" variant="warning">에러</b-badge>
                      <b-badge v-else-if="model.severity == 4" variant="warning">주의</b-badge>
                      <b-badge v-else-if="model.severity == 5" variant="info">정보</b-badge>
                      <b-badge v-else-if="model.severity == 6" variant="info">정보</b-badge>
                      <b-badge v-else variant="dark">미정의</b-badge>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>정책  ID:</label>
                    </b-col>
                    <b-col>
                      {{ model.m_id ? model.m_id : '-' }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>정책명:</label>
                    </b-col>
                    <b-col>
                      {{ policy_domain() ? policy_domain() : '-' }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <label v-b-tooltip.hover>
                        <strong>탐지메세지:</strong>
                      </label>
                    </b-col>
                    <b-col>
                      <strong>{{ i18n_msessage() || '-' }}</strong>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>
                      <label v-b-tooltip.hover>CVE</label>
                    </b-col>
                    <b-col>
                      {{ '-' }}
                    </b-col>
                  </b-row> -->
                  <b-row>
                    <b-col md="3">
                      <label class="font-weight-bold" v-b-tooltip.hover>태그:</label>
                    </b-col>
                    <b-col>
                      <span v-for="x in tags()">
                        {{ x || '-' }} <br>
                      </span>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="parser_request">
              <b-col md="12">
                <b-form-group>
                  <b>
                    <label for="ph_request" v-b-tooltip.hover>
                      URI<small>:</small>
                    </label>
                    <b-button size="sm" @click="view_split_request = !view_split_request" variant="info">
                      {{view_split_uri ? 'split' : 'origin'}} view
                    </b-button>
                  </b>
                  <pre class="bg-secondary" v-if="view_split_request" for="ph_uri" v-b-tooltip.hover>{{model.request}}</pre>
                  <pre v-else class="bg-secondary">{{split_uri(model.request || '')}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr v-if="has_get_parameter()">
            <b-row v-if="has_get_parameter()">
              <b-col sm="6">
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>요청</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.request}}</pre>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>요청 파라미터</label><br></b>
                  <table>
                    <thead>
                      <th class="border border-dark p-2">변수명</th>
                      <th class="border border-dark p-2">값</th>
                    </thead>
                    <tbody>
                      <tr v-for="(x, index) in parameter()" v-bind:key="index">
                        <td class="p-2">
                          {{x.key}}
                        </td>
                        <td class="p-2">
                          {{x.value}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group>
                  <b><label for="ph_seed" v-b-tooltip.hover>요청 헤더</label><br></b>
                  <pre class="bg-light p-4 rounded" style="overflow: scroll;" for="ph_seed" v-b-tooltip.hover>{{model.headers ? model.headers : '헤더 데이터가 없습니다'}}</pre>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <center>
              탐지 정보
              <span class="float-right">
                <span class="text-danger">*</span>
                현재 정책({{model.target}})에서 설정 가능 옵션
              </span>
            </center>
            <hr>
            <table v-if="is_error" class="table table-sm table-dark">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">메세지</th>
                  <th scope="col">정책 ID</th>
                  <!-- <th scope="col">Maturity</th>
                  <th scope="col">Accuracy</th> -->
                  <th scope="col">응답</th>
                  <th scope="col">위험</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <th scope="col" colspan="5">
                    데이터가 잘못되었습니다 기술지원팀에 문의해주세요
                  </th>
                </tr>
              </tbody>
            </table>
            <table v-else class="table table-sm table-dark text-center">
              <thead>
                <tr>
                  <th scope="col" rowSpan="2">#</th>
                  <th scope="col" rowSpan="2">탐지 부분 정보</th>
                  <th scope="col" rowSpan="2">탐지 메세지</th>
                  <th scope="col" rowSpan="2" @click="info_threat = true" style="cursor:pointer">
                    위험
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </th>
                  <!-- <th scope="col" rowSpan="2">Maturity</th>
                  <th scope="col" rowSpan="2">Accuracy</th> -->
                  <!-- <th scope="col" rowSpan="2">Response</th> -->
                  <!-- <th scope="col" rowSpan="2">Risk</th> -->
                  <th v-if="!only_view" scope="col">관리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                  <th scope="row">{{index + 1}}</th>
                  <th scope="row" style="cursor:pointer;" @click="base_policy(row.details.match)">
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                    {{row.value }}
                  </th>
                  <th scope="row">
                    {{ruleI18n[row.details.ruleId] ? ruleI18n[row.details.ruleId]['KO'] : row.message }}
                  </th>
                  <th scope="row">
                    <!-- <p>Policy ID : {{row.details.ruleId}} </p> -->
                    <span>{{row.details.ruleId}} </span>
                    <br>
                    <span>
                      <!-- Response: -->
                      <b-badge v-if="row.is_info" variant="dark">-</b-badge>
                      <b-badge v-else-if="row.is_detect == 0" variant="danger">차단</b-badge>
                      <b-badge v-else variant="warning">탐지</b-badge>
                    </span>
                    <br>
                    <span>
                      <!-- Risk: -->
                      <span scope="row" v-if="row.details.severity == 0"><b-badge variant="danger">심각</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 1"><b-badge variant="danger">경계</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 2"><b-badge variant="danger">치명적</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 3"><b-badge variant="warning">에러</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 4"><b-badge variant="warning">주의</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 5"><b-badge variant="info">정보</b-badge></span>
                      <span scope="row" v-else-if="row.details.severity == 6"><b-badge variant="info">정보</b-badge></span>
                      <span scope="row" v-else><b-badge variant="dark">미정의</b-badge></span>
                    </span>
                  </th>
                  <!-- <th scope="row">{{row.details.maturity}}</th>
                  <th scope="row">{{row.details.accuracy}}</th> -->
                  <!-- <th>
                    <b-badge v-if="row.is_info" variant="dark">-</b-badge>
                    <b-badge v-else-if="row.is_detect == 0" variant="danger">Block</b-badge>
                    <b-badge v-else variant="warning">Detect</b-badge>
                  </th> -->


                  <th v-if="!only_view"  class="text-weight-bold">
                    <b-btn
                      block
                      @click=" exception_info = { applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception }; exception_info_modal_add = true; exception_info_modal_remove = false"
                      size="sm"
                      variant="warning">
                        <span v-if="row.is_domain && !row.is_exception_domain" style="font-size:1.2rem; padding:0px; margin:0px;" class="text-danger">*</span>
                        정책 ({{ row.details.ruleId }}) 끄기
                      </b-btn>
                    <b-btn
                      block
                      @click=" exception_info = { applied : row.exception_list, msg : row.message, detail : row.details, agent_id : model.agent_id, is_exception : row.is_exception }; exception_info_modal_remove = true; exception_info_modal_add = false"
                      size="sm"
                      class="btn-addition"
                      variant="success">
                        <span v-if="row.is_domain && row.is_exception_domain" style="font-size:1.2rem;" class="text-danger">*</span>
                        정책 ({{ row.details.ruleId }}) 켜기
                      </b-btn>
                  </th>
                </tr>
              </tbody>
            </table>
            <hr>

            <b-button v-if="!id" size="sm" class="float-right" @click="list">목록으로</b-button>
          </b-card>
        </b-col>
      </b-row>
      <!-- result modal -->
      <b-modal size="m" title="Risk : Threat description"  class="modal-info" v-model="info_risk" hide-footer @ok="info_risk = false">
        <p>
          <b-badge variant="danger">Emergency</b-badge> :
          인바운드 공격 (inbound attack)과 아웃바운드 유출 (outbound leakage)의 Anomaly Score에 따라 비상 상황을 발생시켜야 하는 경우 사용
        </p>
        <p>
          <b-badge variant="danger">Alert</b-badge> :
          인바운드 공격 (inbound attack)과 아웃바운드 웹 어플리케이션 오류 (outbound application level error)의 연관 상태에 따라 경계 상황을 발생시켜야 하는 경우 사용
        </p>
        <p>
          <b-badge variant="danger">Critical</b-badge> :
          Anomaly Score=5. 다른 탐지 상황과의 연관없이 웹 공격 탐지 룰에 의해서 발생시킬 수 있는 가장 높은 레벨로 중요한 상황의 공격 탐지인 경우 사용
        </p>
        <p>
          <b-badge variant="warning">Error</b-badge> :
          Anomaly Score=4. 대부분 아웃바운드 유출 룰에 의해서 사용
        </p>
        <p>
          <b-badge variant="warning">Warning</b-badge> :
          Anomaly Score=4. 대부분 아웃바운드 유출 룰에 의해서 사용
        </p>
        <p>
          <b-badge variant="info">Notice</b-badge> :
          Anomaly Score=2. 프로토콜 규칙을 지키지 않거나, 이상한 참조 등이 있는 경우 사용
        </p>
        <p>
          <b-badge variant="info">Info</b-badge> :
          기타 정보 데이터가 표시됩니다

        </p>
        <p>
          <b-badge variant="dark">미정의</b-badge> : 위험도가 분류되지 않았을 경우 사용
        </p>
      </b-modal>
      <!-- result modal -->
      <b-modal size="m" title="검출에 대한 상세 설명"  class="modal-info" v-model="info_base_policy.is_show" hide-footer @ok="info_base_policy.is_show = false">
        상세 탐지 근거 정보를 제공합니다
        <hr>
        <pre  style="white-space: pre-wrap; word-break: keep-all;">
          {{info_base_policy.reason}}
        </pre>

      </b-modal>
      <b-modal size="m" title="XFF : X-Forwarded-For"  class="modal-info" v-model="info_xff" hide-footer @ok="info_xff = false">
        XFF: 프록시가 설정 되어 있을 경우 X-Forwarded-For 데이터가 표시됩니다
      </b-modal>
      <b-modal size="l" title="정책 미사용(예외) 설정하기"  class="modal-success" v-model="exception_info_modal_add" @ok="add_white">
        {{exception_policy_id}} 정잭을 예외 처리로 적용할까요?
        <!-- <hr>
        * {{ruleI18n[exception_policy_id] ? ruleI18n[exception_policy_id]['KO'] : exception_policy_name }} -->
        <hr>
        <!-- This Policy({{exception_policy_id}}) applies to "{{exception_policy_name}}" by exception ? -->
        <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in get_domain_list" v-bind:key="index" :value="x" :disabled="exception_info.applied.indexOf(x) > -1">
            {{x}}
          </b-form-checkbox>
        </b-form-checkbox-group>
        <hr>
        <small>* 적용할 정책 대상을 선택해주세요</small>
      </b-modal>
      <b-modal size="m" title="정책 사용(예외 삭제) 설정하기"  class="modal-success" v-model="exception_info_modal_remove" @ok="remove_white">
        정책에 적용되어 있는 예외 정책({{exception_policy_id}})을 삭제 할까요?
        <br>
        방화벽 모드에 따라 탐지 혹은 차단 됩니다
        <hr>
        <b-form-checkbox-group id="target_domain" v-model="exception_info.domain" name="target_domain">
          <b-form-checkbox v-for="x, index in exception_info.applied" v-bind:key="index" :value="x" >{{x}}</b-form-checkbox>
        </b-form-checkbox-group>
        <hr>
        <!-- applied exception policy({{exception_policy_msg}}) remove on "{{exception_policy_name}} policy"? -->
      </b-modal>
      <b-modal size="m" title="Threat"  class="modal-info" v-model="info_threat" hide-footer @ok="info_threat = false">
        [Policy ID] ex) 920320
        <br>
        [Response] ex) Block
        <br>
        [Risk] ex) Notice
      </b-modal>
    </div>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
